const landing = '/landing-page';
const mobileTL = '/mobile-tl';
const mobilePackage = '/mobile-package';
const trendyolGiftCode = '/gift-code/trendyol';
const address = '/address';
const checkout = '/checkout';
const success = '/success';
const orders = '/orders';
const orderContracts = '/orders/contracts';
const giftCodeFaq = '/gift-code/trendyol/faq';
const mobileTLFaq = '/mobile-tl/faq';
const mobilePackageFaq = '/mobile-package/faq';
const raffles = '/raffles';
const raffleResults = '/raffle-results';
const raffleTickets = '/raffle-tickets';
const raffleWinnings = '/raffle-winnings';
const raffleCart = '/raffles/cart';
const raffleFaq = '/raffles/faq';

export default {
  landing,
  mobileTL,
  mobilePackage,
  trendyolGiftCode,
  address,
  checkout,
  success,
  orders,
  orderContracts,
  mobileTLFaq,
  mobilePackageFaq,
  giftCodeFaq,
  raffles,
  raffleResults,
  raffleTickets,
  raffleCart,
  raffleFaq,
  raffleWinnings,
} as const;
